import React, { useRef, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import supportIssuesApi from '../../utils/supportIssuesApi';

const PRIMARY = '#f25d27';
const PRIMARY_DARK = '#d44e1f';

/**
 * @param {{
 *   issueExternalId: string;
 *   disabled?: boolean;
 *   onUploaded: (attachments: import('../../types/support').SupportAttachmentViewModel[]) => void;
 *   onError: (message: string) => void;
 * }} props
 */
export default function SupportAttachmentUploadButton({
  issueExternalId,
  disabled,
  onUploaded,
  onError,
}) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  async function handleFiles(files) {
    if (!files || !files.length) return;
    setUploading(true);

    const uploaded = /** @type {import('../../types/support').SupportAttachmentViewModel[]} */ ([]);

    for (const file of Array.from(files)) {
      try {
        const resp = await supportIssuesApi.uploadAttachment(issueExternalId, file);
        if (!resp.external_id) {
          onError('Anexo enviado, mas a API não retornou identificador.');
          continue;
        }
        uploaded.push({
          id: String(resp.external_id),
          filename: file.name,
          size: file.size,
          content: resp.external_url || undefined,
          created: resp.created_at || new Date().toISOString(),
        });
      } catch {
        onError('Erro ao adicionar anexo.');
      }
    }

    setUploading(false);
    if (uploaded.length) onUploaded(uploaded);

    if (inputRef.current) inputRef.current.value = '';
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        style={{ display: 'none' }}
        onChange={(e) => handleFiles(e.target.files)}
      />
      <Button
        size="small"
        variant="outlined"
        startIcon={uploading ? <CircularProgress size={14} /> : <AttachFileIcon />}
        disabled={disabled || uploading}
        onClick={() => inputRef.current?.click()}
        sx={{
          textTransform: 'none',
          borderRadius: '8px',
          borderColor: PRIMARY,
          color: PRIMARY,
          fontSize: '0.8rem',
          '&:hover': { borderColor: PRIMARY_DARK, color: PRIMARY_DARK, backgroundColor: `${PRIMARY}08` },
        }}
      >
        {uploading ? 'Enviando...' : 'Adicionar anexo'}
      </Button>
    </>
  );
}
